import React from 'react';
import { bool, node, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import css from './Pill.module.css';

export const PILL_TONES = [
  'neutral',
  'success',
  'warning',
  'error',
  'info',
  'brand',
  'creator',
  'org',
  'team',
];

/**
 * A short label: a status (Live now, Scheduled, Draft, Pending approval, Paid, Failed) or an
 * identity tag (Host, Creator, Organization, Team, You, Pass holder). The tone picks the colours
 * from the design tokens, so it looks the same in the public and the dashboard family.
 * The caller passes the translated text.
 */
const Pill = props => {
  const { rootClassName, className, tone, size, dot, children } = props;
  const classes = classNames(
    rootClassName || css.root,
    css[tone],
    { [css.small]: size === 'small' },
    className
  );
  return (
    <span className={classes}>
      {dot ? <span className={css.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  );
};

Pill.defaultProps = {
  rootClassName: null,
  className: null,
  tone: 'neutral',
  size: 'default',
  dot: false,
};

Pill.propTypes = {
  rootClassName: string,
  className: string,
  tone: oneOf(PILL_TONES),
  // small is the 20px count after a tab label ("Episodes 12")
  size: oneOf(['default', 'small']),
  // A dot before the label, as in "● Live now"
  dot: bool,
  children: node.isRequired,
};

export default Pill;
